export default "__VITE_ASSET__BT8mfil0__"